import { render, staticRenderFns } from "./sdproduct10.vue?vue&type=template&id=1cea3902&scoped=true"
import script from "./sdproduct10.vue?vue&type=script&lang=js"
export * from "./sdproduct10.vue?vue&type=script&lang=js"
import style0 from "./sdproduct10.vue?vue&type=style&index=0&id=1cea3902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea3902",
  null
  
)

export default component.exports